// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"d271c437","143":"22c74dae","283":"c80e5ab6","284":"4b883b8c","637":"c9cd93ae","656":"d5ab25a5","748":"dc9d2f54","767":"9f665ec8","854":"cc02c1de","878":"9e7ab95e","956":"8ec6cb6e","999":"c34083e7"}[chunkId] + ".chunk.js";
};